import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { VesignDataService } from '../service/vesign-data.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-view-vendor-con-information-docs',
  templateUrl: './view-vendor-con-information-docs.component.html',
  styleUrls: ['./view-vendor-con-information-docs.component.css']
})
export class ViewVendorConInformationDocsComponent implements OnInit {

  PackageList = [];
  IsemailWrapPopupOpen: boolean = false;
  emailWrapStyle = [];
  EmailLogId: number = 0;
  EmailId: string = "";
  VendorConsDocList = [];
  VendorConsDocDropList = [];
  TaskId: number = 0;
  DocType: string = "";
  paramsObject;

  SearchBy={
    SearchBySpecificColumns: '',
    Vendor_code:'',
    taskId: null,
  }
  PinActiverecords: any={
    pinID:0,
    task_id:'',
    envMstrID:'',
    EmailLogId:'',
    IsActive:true,
    Doc_Type:''
  }
  
  Search = {
    vendorCode: "",
    taskId: null,
    gcId: null,
    search: null
  }
  constructor(private location: Location,private route: ActivatedRoute, private dataService: VesignDataService<any>, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.spinner.show();
    this.dataService.setVendorName(sessionStorage.getItem('UserName')!=null ? sessionStorage.getItem('UserName').toString() : "");
    this.route.queryParamMap.subscribe((params) => {
      this.paramsObject = { ...params.keys, ...params }
      //localStorage.setItem("Vendor_code", this.paramsObject.params.Vendor_code);
      //this.SearchBy.Vendor_code = this.paramsObject.params.Vendor_code;
      this.SearchBy.Vendor_code=sessionStorage.getItem("VendorCode");
    
      if (this.paramsObject.params.taskId != undefined) {
        this.SearchBy.taskId = this.paramsObject.params.taskId;
      }
      this.location.replaceState('/viewinformationdocs');
      this.GetVendorConsultantInformationDocsPackages(this.SearchBy);
     
    });

    this.Search.vendorCode = sessionStorage.getItem("VendorCode");
     this.getTakeActionPendingDocsCount(this.Search);
     this.SearchBy.Vendor_code=this.Search.vendorCode;
     this.GetViewCompletedDocsCount(this.SearchBy);
   // this.GetViewCompletedDocsCount();
    this.spinner.hide();
    
  }
  getTakeActionPendingDocsCount(search: any) {
    this.dataService.Post(environment.eSignApiUrl + "/api/TakeAction/GetEsignConsultantPendingPackagesCount", search)
      .subscribe(
        (response: any) => {
          this.dataService.setTakeActionCount(response);
          // console.log(response);
        },
        error => {
          console.log(error);
        });
  }
  GetViewCompletedDocsCount(search: any) {
    //debugger;
    this.dataService.Post(environment.eSignApiUrl + "/api/VendorEsign/GetVendorConsultantCompleteDocsCount", search)
      .subscribe((response: any) => {
        debugger;
        //console.log(response);
        this.dataService.setVendorViewCompeletedDocsCount(response);
      });
  }
  emailWrapPopup(emailLogId) {
    this.IsemailWrapPopupOpen = !this.IsemailWrapPopupOpen;
    if (this.IsemailWrapPopupOpen) { this.emailWrapStyle[emailLogId] = "custom_modal active" }
    else { this.emailWrapStyle[emailLogId] = "custom_modal" }
  }

  UnPinVendorConsselectedDocs(taskId,envMstrID,EmailLogId,pinID,doc_type)
  {
    this.PinActiverecords.task_id = taskId;
    this.PinActiverecords.envMstrID = envMstrID;
    this.PinActiverecords.EmailLogId=EmailLogId;
    this.PinActiverecords.pinID=pinID;
    this.PinActiverecords.Doc_Type=doc_type;
    
    this.dataService.Post(environment.eSignApiUrl + "/api/VendorEsign/InsPinVendorCompletedocsActiveRecords",this.PinActiverecords)
      .subscribe(        
       res => {    
        
        //console.log(res);
          //this.notify.successMsg("Record Pined Successfully.");  
          this.GetVendorConsultantInformationDocsPackages(this.SearchBy);
        },
        error => {
          console.log(error);
         //this.spinner.hide();
        });
  }
  
  PinVendorConsselectedDocs(taskId,envMstrID,EmailLogId,Doc_type)
  {
    this.PinActiverecords.task_id = taskId;
    this.PinActiverecords.envMstrID = envMstrID;
    this.PinActiverecords.EmailLogId=EmailLogId;
    this.PinActiverecords.Doc_Type=Doc_type;
    //this.pinID=pinID;
   
    this.dataService.Post(environment.eSignApiUrl + "/api/VendorEsign/InsPinVendorCompletedocsActiveRecords",this.PinActiverecords)
      .subscribe(        
       res => {    
        
        //console.log(res);
          //this.notify.successMsg("Record Pined Successfully.");  
          this.GetVendorConsultantInformationDocsPackages(this.SearchBy);
        },
        error => {
          console.log(error);
         //this.spinner.hide();
        });
  }

  GetVendorConsultantInformationDocsPackages(SearchBy:any)
  {
    
   
    this.dataService.Post(environment.eSignApiUrl + "/api/VendorEsign/GetVendorConsultantInformationDocsPackages", SearchBy)
      .subscribe(        
        (response: any) => {          
          //console.log(response);
          this.PackageList = response;      
          
        },
        error => {
          console.log(error);
         
        });
  }

  ViewVendorConInformationDocuments(taskId,EmailLogId,EmailId)
  {
    
   
    this.EmailLogId = EmailLogId;
    this.EmailId = EmailId;
    if(this.VendorConsDocDropList.length != 0)
    {
      this.VendorConsDocDropList = [];
      this.DocType = '';
     
    }
    else{
    this.spinner.show(); 
    
    this.VendorConsDocList = [];
    this.VendorConsDocDropList = [];
    this.DocType = '';

    this.dataService.Get(environment.eSignApiUrl + "/api/VendorEsign/ViewVendorConInformationDocuments?TaskID=" + taskId +"&EmailLogId=" + EmailLogId, null)
      .subscribe(
        (response: any) => {
          this.VendorConsDocList = response;          
          this.VendorConsDocList.forEach((value, index) => {
            if (this.DocType != value.doc_category) {                   
              {
                this.VendorConsDocDropList.push({ SNO: value.sno, DocCategory: value.doc_category, DocList: [] });
              }                      
              this.DocType = value.doc_category              
            }
             let latestIndex: any = this.VendorConsDocDropList.length - 1;            
             this.VendorConsDocDropList[latestIndex].DocList.push({ DocID: value.sno, DocCategory: value.doc_category, FilePath: value.filePath, IsEditable: (value.filePath.split('.').pop() == "aspx" || value.filePath.split('.').pop() == "asp") ? true : false , DocName: value.actual_Form_Name, TaskID : value.task_id, Signed: value.signed, FileContent: value.uploadedFileData, UploadedFileName: value.uploadedFileName,DocuSignStatus: value.docuSign_Status });

          });
          this.spinner.hide();
        },
        error => {
          console.log(error);
          this.spinner.hide();
        });
        console.log(this.VendorConsDocDropList);    
    }
  }

}
